/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 15:50:31 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Datagrid,
  DateField,
  Title,
  TextField,
  List,
  useTranslate,
} from 'react-admin';
import { PostPagination } from '../../Components/CustomPagination/pagination';
import { usePersistentOrganisation } from '../../Components/Contexts';
import TowerFilter from './filter';
import TowerActions from './actions';

const TowerList = props => {
  const translate = useTranslate();
  const {
    persistentOrganisation,
    onSelectPersistentOrganisation,
  } = usePersistentOrganisation();

  return (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        filterDefaultValues={{
          organisationId: persistentOrganisation.id,
        }}
        title={translate('resources.Tower.name', { smart_count: 2 })}
        bulkActionButtons={false}
        perPage={25}
        actions={persistentOrganisation.id ? <TowerActions /> : null}
        pagination={<PostPagination />}
        exporter={false}
        filters={
          <TowerFilter
            organisationId={persistentOrganisation.id}
            organisationFilter={onSelectPersistentOrganisation}
          />
        }
        {...props}
      >
        <Datagrid
          rowClick={(id, basePath, record) => {
            return {
              pathname: `/Tower/${record.id}`,
              state: {
                organisationId: persistentOrganisation.id,
              },
            };
          }}
        >
          <TextField
            source="id"
            label={'resources.Tower.fields.id'}
            sortable={false}
          />
          <TextField
            sortable={false}
            label="resources.Tower.fields.organisation"
            source="site.project.organisation.name"
          />
          <TextField
            source="site.project.name"
            label={'resources.Tower.fields.project'}
            sortable={false}
          />
          <TextField
            source="site.name"
            label={'resources.Tower.fields.site'}
            sortable={false}
          />
          <DateField
            source="createdAt"
            label={'resources.Tower.fields.date'}
            sortable={false}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default TowerList;
